import type { ReactNode } from "react";

type EmptyStateProps = {
  title: string;
  body: string;
  action?: ReactNode;
};

export function EmptyState({ title, body, action }: EmptyStateProps) {
  return (
    <div className="orbit-card flex min-h-52 flex-col items-center justify-center border-dashed p-8 text-center">
      <h3 className="orbit-display text-base font-semibold text-slate-950">
        {title}
      </h3>
      <p className="mt-2 max-w-md text-sm text-slate-500">{body}</p>
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
